import { render, staticRenderFns } from "./PerformanceLevel.vue?vue&type=template&id=9ea7201c&scoped=true&"
import script from "./PerformanceLevel.vue?vue&type=script&lang=ts&"
export * from "./PerformanceLevel.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceLevel.vue?vue&type=style&index=0&id=9ea7201c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea7201c",
  null
  
)

export default component.exports